module.exports = __webpack_public_path__ + "static/media/force-desktop-message.25386cfe.jpg";